import { cva } from 'class-variance-authority';

export const cvaButton = cva(
  [
    'ButtonStyles-cvaButton',
    'relative',
    'inline-flex items-center  gap-0.8',
    'group/button cursor-pointer select-none disabled:cursor-not-allowed',
    'rounded-[0.8rem]',
    'text-l-b',
    'disabled:pointer-events-none focus-visible:outline-none',
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-cGreen active:bg-cDarkGreen',
          'border-cGreen',
          'text-cWhite',
        ],
        gray: ['bg-cGray active:bg-cDarkGray', 'text-cWhite'],
        darkGray: ['bg-cSecondaryGray active:bg-cGray', 'text-cWhite'],
        red: [
          'bg-none',
          'text-cRed',
          'border-[2px] border-cRed [&_svg]:fill-cRed',
        ],
        fullRed: ['bg-cRed', 'text-cRed', 'border-[2px] border-cRed'],
        noneBg: [
          'bg-none  active:bg-cGray',
          'text-cWhite',
          'border-[3px] border-cSecondaryGray',
        ],
      },
      theme: {},
      justify: {
        center: ['justify-center'],
        start: ['justify-start'],
      },
      size: {
        common: ['px-1.6 py-1.4 min-h-5.2'],
        nonPadding: ['p-0'],
        tabs: ['px-1.6 pt-1.2 pb-1 min-h-5'],
      },
      rubber: {
        true: ['flex-1'],
        false: [''],
      },
      isDisabled: {
        true: ['opacity-60'],
        false: [],
      },
    },
    defaultVariants: {},
  }
);

export const cvaIcon = cva(
  [
    'ButtonStyles-cvaIcon',
    'inline-flex justify-center items-center',
    'text-0',
    'rounded-full',
  ],
  {
    variants: {
      theme: {},
      size: {},
      isLoading: {},
    },
    defaultVariants: {},
  }
);

export const cvaButtonInner = cva(
  ['ButtonStyles-cvaButtonInner', 'block overflow-hidden'],
  {
    variants: {
      size: {},
    },
  }
);

export const cvaButtonInnerRow = cva([
  'ButtonStyles-cvaButtonInnerRow',
  'relative',
  'block',
]);
